import type {
  SupplierProductGetResponseChildType,
  ProductUpdateRequestTypeBadgeType,
} from "@sellar-io/api-v2/types";
import { useId } from "react";
import { useForm } from "react-hook-form";
import { BasicDialog } from "../../../../components/modal/BasicDialog";
import { InputField, InputText } from "@sellar-io/components";

export default function ProductBadgeEditDialog({
  product,
  onUpdate,
  loading,
  active,
  onDismiss,
}: {
  product?: SupplierProductGetResponseChildType;
  onUpdate: (item: ProductUpdateRequestTypeBadgeType) => void;
  loading?: boolean;
  active: boolean;
  onDismiss: () => void;
}) {
  const formId = useId();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      sku: product?.sku ?? "",
      type: "badge" as const,
    },
    shouldUseNativeValidation: true,
  });

  return (
    <BasicDialog
      loading={loading}
      onDismiss={onDismiss}
      dialogActive={active}
      title={`Update item`}
      confirmFormId={formId}
    >
      <form
        id={formId}
        onSubmit={handleSubmit(onUpdate)}
        className={"flex flex-col gap-2"}
      >
        <InputField label={"SKU"}>
          <InputText
            {...register("sku", { required: false })}
            placeholder={"Optional"}
          />
        </InputField>
      </form>
    </BasicDialog>
  );
}
